// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1uRv1","title":"styles_title__Xu4Ye"};